// @flow
import React from 'react';

// Components
import AppointmentInfo from 'components/molecules/AppointmentInfo/';
import StartScreenSearch from 'components/organisms/StartScreenSearch/';
import StartScreenOptions from 'components/molecules/StartScreenOptions/';
import ContentFooter from 'components/pages/components/ContentFooter';
import QuoteApptError from 'components/api/components/QuoteApptError/QuoteApptError';
// CTA
import type { CTA } from 'api/xws/optimizely/optimizely';

import './StartPage.scss';

export type Props = {
  CTABanner: CTA | null,
  showQuoteApptError: boolean,
  setShowQuoteApptError: boolean => void
};

const StartPage = ({
  CTABanner,
  showQuoteApptError,
  setShowQuoteApptError
}: Props) => {
  return (
    <React.Fragment>
      <header>
        <AppointmentInfo key="appointmentInfo" />
      </header>
      <main>
        {showQuoteApptError && (
          <QuoteApptError
            isOpen={showQuoteApptError}
            onClose={() => setShowQuoteApptError(false)}
          />
        )}
        <StartScreenSearch key="startScreenSearch" />
        <StartScreenOptions key="startScreenOptions" />
      </main>
      <footer>
        <ContentFooter />
      </footer>
    </React.Fragment>
  );
};

export default StartPage;



// WEBPACK FOOTER //
// ./src/components/pages/StartPage/StartPage.js